import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import { ShieldCheck } from 'lucide-react';
import { SectionCard, setField } from './SettingsUI';

const DistributionTab = ({ form, setForm }) => {
  const { t } = useTranslation();
  return (
  <div className="row g-3">
    <div className="col-lg-8">
      <SectionCard title={t('settings.distribution.title')} icon={ShieldCheck}>
        <p className="text-muted small mb-3">
          {t('settings.distribution.intro')}
        </p>
        <div className="q2c-dist-option mb-3">
          <Form.Check
            type="radio"
            id="dist-load-balanced"
            name="distributionMode"
            label={
              <span>
                <strong>{t('settings.distribution.loadBalanced')}</strong>
                <span className="d-block small text-muted">
                  {t('settings.distribution.loadBalancedDesc')}
                </span>
              </span>
            }
            value="load_balanced"
            checked={form.distributionMode === 'load_balanced'}
            onChange={() => setField(setForm, 'distributionMode', 'load_balanced')}
          />
        </div>
        <div className="q2c-dist-option">
          <Form.Check
            type="radio"
            id="dist-manual"
            name="distributionMode"
            label={
              <span>
                <strong>{t('settings.distribution.manual')}</strong>
                <span className="d-block small text-muted">
                  {t('settings.distribution.manualDesc')}
                </span>
              </span>
            }
            value="manual"
            checked={form.distributionMode === 'manual'}
            onChange={() => setField(setForm, 'distributionMode', 'manual')}
          />
        </div>
      </SectionCard>
    </div>
  </div>
  );
};

export default DistributionTab;
